import { useNavigate } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';

import { PKDFilledButton } from 'components/FilledButton';
import DefaultWrapper from 'shared-components/DefaultWrapper';
import { ReactComponent as Completed } from 'images/shared/done-checkmark.svg';

const CareCenterAdded = () => {

  const navigate = useNavigate();
  const handleClick = () => navigate('/my-care-network');

  const crumbs = [
    { title: 'My Care Network', isActive: false, linkTo: '/my-care-network' },
    { title: 'Add Care Center', isActive: true },
  ];

  return (
    <DefaultWrapper
      crumbs={crumbs}
      showHeader={true}>
      <Stack
        alignItems='center'
        justifyContent='center'
        flex={1}>
        <Stack
          spacing='25px'
          width='300px'>
          <Stack
            spacing='50px'
            alignItems='center'>
            <Completed
              width={151}
              height={151}
            />
            <Stack
              spacing='15px'
              alignItems='center'>
              <Typography
                variant='h4'
                color='secondary.gray4'
                align='center'>
                Thank you for sharing your MyChart health record
              </Typography>
              <Typography
                variant='pl4'
                color='secondary.gray4'
                align='center'>
                Your health record will be used in the study
              </Typography>
            </Stack>
          </Stack>
          <PKDFilledButton
            width='224px'
            onClick={handleClick}>
            Done
          </PKDFilledButton>
        </Stack>
      </Stack>
    </DefaultWrapper>
  );
};

export default CareCenterAdded;
